import swal from "sweetalert2";
import { get } from "lodash";

/**
 * @typedef OptionsObject
 * @type {{ title?: String }}
 */

/**
 * Show an error on a sweetalert
 *
 * @param {Error} error an error object
 * @param {OptionsObject} [options]
 */
export const handleError = async (error, { title = "Error" } = {}) => {
  console.error(error);

  await swal({
    title: get(error, "title") ? error.title : title,
    text: error ? (error.detail ? error.detail : error.message) : "",
    type: "error",
  });
};
